import { render, staticRenderFns } from "./OxygenCodeInput.vue?vue&type=template&id=2b615c44&"
import script from "./OxygenCodeInput.vue?vue&type=script&lang=ts&"
export * from "./OxygenCodeInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports